import React from 'react';
import { helpDeskMailIFERP } from 'utils/helpers';
// Coupon or Voucher follow ups
const SecondStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    coupon_code,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <strong>
        <p>{client_name ? `Hi ${client_name},` : `Hi [Recipient's Name],`}</p>
        <p>
          We noticed you haven’t yet used your special discount voucher for{' '}
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
          . Don’t miss out on this exclusive opportunity to register and save!
        </p>

        <p>
          The conference will take place on{' '}
          {conference_from_date && conference_to_date
            ? `${conference_from_date} - ${conference_to_date}`
            : `[Conference from and to Date]`}{' '}
          at{' '}
          {conference_location ? conference_location : `[Conference Location]`},
          and we’d love for you to join us.
        </p>
        <p>
          👉 Use your coupon code {coupon_code ? coupon_code : `[Coupon Code]`}{' '}
          now and secure your spot at a discounted rate:{' '}
          {registration_link ? (
            <a
              href={registration_link}
              target="_blank"
              // rel="noopener noreferrer"
            >
              Click Here
            </a>
          ) : (
            `[Registration Link]`
          )}
        </p>

        <p>
          This is your chance to: <br />
          ✅ Gain valuable insights from industry experts
          <br />
          ✅ Network with like-minded professionals
          <br />✅ Earn a CPD certification
        </p>

        <p>
          Let me know if you have any questions or need assistance with
          registration. Looking forward to seeing you there! <br />
        </p>
      </strong>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default SecondStepTemplate;
